'use client'

import { useState } from 'react'
import { AnimatePresence, motion } from 'motion/react'

import ComparisonsMenu from '@/components/navigation/menus/ComparisonsMenu'

import { Icon } from '@/icons/Icon'
import { cn } from '@/lib/utils'
import { HeaderContextProvider } from '@/context/HeaderContext'
import { easeShort } from '@/lib/transitions'

export default function ComparisonsPicker() {
  const [showMenu, setShowMenu] = useState(false)

  return (
    <HeaderContextProvider>
      <div className="relative">
        <button
          onClick={() => setShowMenu(!showMenu)}
          className={cn(
            'flex h-9 items-center gap-3.5 rounded-lg border bg-gray-50 px-3 py-2 text-14 font-medium leading-tight text-gray-800 transition-colors dark:bg-white/10 dark:text-white',
            showMenu
              ? 'border-black/20 dark:border-white/20'
              : 'border-black/5 hover:border-black/20 dark:border-white/10 dark:hover:border-white/20',
          )}
        >
          <Icon name="duplicate" className="text-gray-500 dark:text-white/40" />
          <span className="whitespace-nowrap">Create Comparison</span>
          <div
            className={cn(
              showMenu ? 'rotate-90' : '-rotate-90',
              'text-gray-500 transition-transform duration-300 dark:text-white/40',
            )}
          >
            <Icon name="chevron-left" size={12} />
          </div>
        </button>

        <AnimatePresence>
          {showMenu && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={easeShort}
            >
              <div className="absolute left-0 top-11 h-fit max-h-[475px] overflow-hidden rounded border border-gray-200 bg-white shadow-xl dark:border-white/10 dark:bg-black">
                <ComparisonsMenu filter={true} />
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </HeaderContextProvider>
  )
}
